import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import useReorderQuestions from "./useReorderQuestions";

export default function useQuestions(){

    const {quizId} = useParams()

    const reorderQuestions = useReorderQuestions()

    return useQuery({

        queryKey: ['design', quizId, 'questions'],

        queryFn: () => API.get(`/design/sections/${quizId}/questions`)
            .then(r => reorderQuestions(r.data)),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};